import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthPage } from '@/pages/AuthPage';
import { AuthCallback } from '@/components/Auth/AuthCallback';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { ToolOverview } from '@/pages/ToolOverview';
import { CVRTool } from '@/pages/CVRTool';
import { EVMTool } from '@/pages/EVMTool';
import { TargetCostTool } from '@/pages/TargetCostTool';
import { WhatsAppAnalyzer } from '@/pages/WhatsAppAnalyzer';
import { EarlyWarningRegister } from '@/pages/EarlyWarningRegister';
import { SettingsPage } from '@/pages/SettingsPage';
import { Error400Page } from '@/pages/Error400Page';
import { PrivateRoute } from './PrivateRoute';
import { EVMProvider } from '@/context/EVMContext';
import { TargetCostProvider } from '@/context/TargetCostContext';
import { EarlyWarningProvider } from '@/context/EarlyWarningContext';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
      <Route path="/400" element={<Error400Page />} />
      
      {/* Protected routes */}
      <Route path="/" element={<PrivateRoute />}>
        <Route index element={<ToolOverview />} />
        <Route path="cvr" element={<CVRTool />} />
        <Route 
          path="evm" 
          element={
            <EVMProvider>
              <EVMTool />
            </EVMProvider>
          } 
        />
        <Route 
          path="target-cost" 
          element={
            <TargetCostProvider>
              <TargetCostTool />
            </TargetCostProvider>
          } 
        />
        <Route 
          path="early-warning-register" 
          element={
            <EarlyWarningProvider>
              <EarlyWarningRegister />
            </EarlyWarningProvider>
          } 
        />
        <Route path="whatsapp-analyzer" element={<WhatsAppAnalyzer />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/400" replace />} />
    </Routes>
  );
}